import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface BotelCardProps {
  index: number;
  title: string;
  price: string;
  distance: string;
  security: string;
  imageUrl: string;
  onClick?: () => void;
}

const BotelCard = ({ index, title, price, distance, security, imageUrl, onClick }: BotelCardProps) => {
  const navigate = useNavigate();

  return (
    <Box sx={{
      bgcolor: '#181D23',
      borderRadius: 4,
      boxShadow: 6,
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      minHeight: 370,
      cursor: 'pointer',
    }}
    onClick={onClick}
    >
      {/* Status Tag */}
      <Box sx={{
        position: 'absolute',
        top: 20,
        right: 20,
        bgcolor: index % 3 === 0 ? '#FFD600' : '#22C55E',
        color: '#181D23',
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontWeight: 700,
        fontSize: 14,
        zIndex: 2,
      }}>
        {index % 3 === 0 ? 'Few Left' : 'Available Now'}
      </Box>
      {/* Image */}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 2 }}>
        <img
          src={imageUrl}
          alt="Botel"
          style={{ width: '100%', height: 180, objectFit: 'cover', borderRadius: 12 }}
          loading="lazy"
          onError={e => { (e.target as HTMLImageElement).src = '/images/botelOne.png'; }}
        />
      </Box>
      {/* Title & Price */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" width="100%">
        <Typography variant="h6" fontWeight={700} color="#fff" sx={{ mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="subtitle1" color="#fff" sx={{ fontWeight: 600, mb: 1 }}>
          {price}
        </Typography>
      </Stack>
      {/* Distance & Security */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Typography variant="body2" color="#b0b8c1" sx={{ mb: 0.5 }}>
          {distance}
        </Typography>
        <Typography variant="body2" color="#b0b8c1" sx={{ mb: 2 }}>
          {security}
        </Typography>
      </Stack>
      {/* Book Now Button */}
      <Button
        variant="contained"
        fullWidth
        sx={{
          bgcolor: '#2563EB',
          color: '#fff',
          fontWeight: 700,
          borderRadius: 2,
          fontSize: 16,
          mt: 'auto',
          py: 1.2,
          '&:hover': { bgcolor: '#1746A0' },
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
      >
        Book Now
      </Button>
    </Box>
  );
};

export default BotelCard; 